/**
 * Serialisable snapshot annotation data model.
 *
 * These are the pure data types persisted on a ViewportSnapshot. The
 * interactive annotation objects (classes, canvas rendering, hit testing)
 * live in the React layer (`components/snapshot/annotation`); only the
 * wire format belongs here. All coordinates are in image-natural-pixel space.
 */

export enum AnnotationType {
    ARROW = 'arrow',
    CIRCLE = 'circle',
    TEXT = 'text',
}

export interface AnnotationStyle {
    color: string;
    lineWidth: number;
    fontSize: number;
    fontFamily: string;
    bold: boolean;
    italic: boolean;
}

export const DEFAULT_ANNOTATION_STYLE: AnnotationStyle = {
    color: '#FF3333',
    lineWidth: 2,
    fontSize: 16,
    fontFamily: 'sans-serif',
    bold: false,
    italic: false,
};

export interface ArrowAnnotationData {
    type: AnnotationType.ARROW;
    id: string;
    start: { x: number; y: number };
    end: { x: number; y: number };
    style: AnnotationStyle;
}

export interface EllipseAnnotationData {
    type: AnnotationType.CIRCLE;
    id: string;
    center: { x: number; y: number };
    radiusX: number;
    radiusY: number;
    style: AnnotationStyle;
}

export interface TextAnnotationData {
    type: AnnotationType.TEXT;
    id: string;
    position: { x: number; y: number };
    text: string;
    style: AnnotationStyle;
}

export type AnnotationData = ArrowAnnotationData | EllipseAnnotationData | TextAnnotationData;
